/* app/js/src/components/publishing-status/publishing-event-card/publishing-event-card.component.scss */
.cursor-pointer {
  cursor: pointer;
}
@keyframes cs-pub-catalog-overlay-fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
:host {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  -webkit-transition: background-color 0.15s ease;
  transition: background-color 0.15s ease;
}
:host:hover {
  background-color: rgb(233, 248, 255);
}
:host.publishing-table__row--selected {
  background-color: rgb(233, 248, 255);
}
.publishing-table__td {
  padding: 12px 15px 12px 20px;
  vertical-align: middle;
  background-color: inherit;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
}
.publishing-table__td--checkbox {
  width: 44px;
  text-align: center;
  padding-left: 12px;
  padding-right: 8px;
}
.publishing-table__td--checkbox mat-checkbox {
  position: relative;
  top: 3px;
}
.publishing-table__td--preview {
  width: 112px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.publishing-table__td--title,
.publishing-table__td--platform,
.publishing-table__td--destination,
.publishing-table__td--date,
.publishing-table__td--status {
  min-width: 0;
}
.publishing-table__td--actions {
  width: 104px;
  padding-left: 8px;
  padding-right: 8px;
  text-align: center;
}
.publishing-table__actions-cell {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  gap: 4px;
}
.publishing-table__edit-btn {
  display: inline-flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 4px;
  background-color: transparent;
  color: rgb(114, 125, 139);
  cursor: pointer;
  -webkit-transition: all 0.15s ease;
  transition: all 0.15s ease;
}
.publishing-table__edit-btn:hover {
  background-color: rgb(233, 248, 255);
  color: rgb(45, 187, 252);
  border-color: rgba(45, 187, 252, 0.5);
}
.publishing-table__edit-btn:active {
  background-color: rgb(41, 170, 229);
  color: rgb(255, 255, 255);
  border-color: rgb(45, 187, 252);
}
.publishing-table__edit-btn:focus-visible {
  outline: none;
  background-color: rgb(233, 248, 255);
  color: rgb(45, 187, 252);
  border-color: rgba(45, 187, 252, 0.5);
  box-shadow: 0 0 0 2px rgba(45, 187, 252, 0.25);
}
.publishing-table__edit-btn:disabled {
  opacity: 0.5;
  cursor: default;
  pointer-events: none;
}
.publishing-table__mam-icon {
  display: inline-flex;
  width: 16px;
  height: 16px;
  pointer-events: none;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.publishing-table__mam-icon ::ng-deep svg {
  width: 16px;
  height: 16px;
}
.publishing-table__mam-icon ::ng-deep path,
.publishing-table__mam-icon ::ng-deep use,
.publishing-table__mam-icon ::ng-deep rect {
  fill: currentColor !important;
  stroke: none !important;
}
.publishing-table__mam-icon ::ng-deep title {
  display: none;
}
.event-card__thumbnail {
  position: relative;
  width: 96px;
  height: 56px;
  flex-shrink: 0;
  overflow: hidden;
  border-radius: 4px;
  background: rgba(35, 47, 58, 0.05);
}
.event-card__thumbnail-img {
  position: absolute;
  inset: 0;
  display: block;
  -webkit-transition: transform 0.4s ease;
  transition: transform 0.4s ease;
}
.event-card__thumbnail:hover .event-card__thumbnail-img {
  -ms-transform: scale(1.05);
  -webkit-transform: scale(1.05);
  transform: scale(1.05);
}
.event-card__thumbnail-img img {
  width: 100%;
  height: 100%;
  object-fit: scale-down;
  opacity: 0.8;
  display: block;
}
.event-card__card-overlay {
  background-color: rgba(35, 47, 58, 0.8);
  position: absolute;
  inset: 0;
  z-index: 1;
  display: none;
  animation: cs-pub-catalog-overlay-fadeIn 0.3s forwards;
}
.event-card__thumbnail:hover .event-card__card-overlay {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.event-card__card-overlay section {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  gap: 12px;
  margin: 0;
}
.event-card__overlay-btn {
  display: block;
  width: 20px;
  height: 20px;
  background: none;
  border: none;
  padding: 0;
  position: relative;
  cursor: pointer;
  color: #93a9bf;
  text-decoration: none;
}
.event-card__overlay-btn:focus {
  outline: none;
}
.event-card__overlay-btn:hover {
  color: rgb(255, 255, 255);
}
.event-card__overlay-btn:hover::after {
  -ms-transform: translateY(2px);
  -webkit-transform: translateY(2px);
  transform: translateY(2px);
  opacity: 1;
}
.event-card__overlay-btn::after {
  content: attr(data-title);
  color: rgb(255, 255, 255);
  font-size: 0.7em;
  margin-left: -10px;
  display: block;
  opacity: 0;
  position: absolute;
  left: -50%;
  top: 16px;
  width: 300%;
  text-align: center;
  white-space: nowrap;
  pointer-events: none;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  -ms-transform: translateY(8px);
  -webkit-transform: translateY(8px);
  transform: translateY(8px);
}
.event-card__overlay-btn-icon {
  display: block;
  width: 20px;
  height: 20px;
}
.event-card__overlay-btn-icon ::ng-deep svg {
  width: 20px;
  height: 20px;
  display: block;
  fill: currentColor;
  stroke: currentColor;
}
.event-card__title {
  margin: 0;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.event-card__platform {
  display: inline-flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  gap: 6px;
}
.event-card__platform-icon-wrap {
  display: inline-flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  flex-shrink: 0;
}
.event-card__platform-icon {
  width: 16px;
  height: 16px;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.event-card__platform-icon ::ng-deep svg {
  width: 16px;
  height: 16px;
  display: block;
}
.event-card__platform-icon-wrap.platform--youtube {
  color: #ff0000;
}
.event-card__platform-icon-wrap.platform--facebook {
  color: #1877f2;
}
.event-card__platform-icon-wrap.platform--instagram {
  color: #e4405f;
}
.event-card__platform-icon-wrap.platform--twitter {
  color: #1da1f2;
}
.event-card__platform-icon-wrap.platform--tiktok {
  color: #000000;
}
.event-card__platform-icon-wrap.platform--website,
.event-card__platform-icon-wrap.platform--default {
  color: rgba(0, 0, 0, 0.54);
}
.event-card__account {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.event-card__placeholder {
  color: rgba(0, 0, 0, 0.54);
}
.event-card__status-cell {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-align-items: flex-start;
  -ms-flex-align: flex-start;
  align-items: flex-start;
  gap: 4px;
  min-width: 0;
  max-width: 100%;
}
.event-card__error {
  margin: 0;
  font-size: 12px;
  line-height: 1.35;
  font-weight: 600;
  color: rgb(255, 76, 81);
  font-style: italic;
  white-space: normal;
}
.event-card__datetime {
  font-weight: 400;
  white-space: nowrap;
}
.event-card__badge {
  display: inline-flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  gap: 8px;
  font-weight: 400;
  color: inherit;
}
.event-card__badge.status-cell .event-card__status-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.event-card__badge.status-cell .event-card__status-icon ::ng-deep svg {
  width: 18px;
  height: 18px;
  display: block;
}
.event-card__badge.status--success .event-card__status-icon ::ng-deep path,
.event-card__badge.status--success .event-card__status-icon ::ng-deep g {
  fill: #61b965;
}
.event-card__badge.status--failed .event-card__status-icon ::ng-deep path,
.event-card__badge.status--failed .event-card__status-icon ::ng-deep g {
  fill: #ef5350;
}
.event-card__badge.status--scheduled .event-card__status-icon ::ng-deep path,
.event-card__badge.status--scheduled .event-card__status-icon ::ng-deep g {
  fill: rgb(22, 177, 255);
}
.event-card__badge.status--processing .event-card__status-icon ::ng-deep path,
.event-card__badge.status--processing .event-card__status-icon ::ng-deep g {
  fill: rgb(255, 180, 0);
}
.event-card__badge.status--success-with-warnings .event-card__status-icon ::ng-deep path,
.event-card__badge.status--success-with-warnings .event-card__status-icon ::ng-deep g {
  fill: rgb(255, 180, 0);
}
.event-card__badge.status--draft .event-card__status-icon ::ng-deep path,
.event-card__badge.status--draft .event-card__status-icon ::ng-deep g {
  fill: rgba(0, 0, 0, 0.54);
}
/*# sourceMappingURL=publishing-event-card.component.css.map */
